/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import SVGIcon from 'react-md/lib/SVGIcons/SVGIcon';
import './icon.module.scss';

const Edit = props => (
  <SVGIcon
    {...props}
    role="presentation"
    viewBox="259.243 168.017 32.095 29.997"
  >
    <path
      d="M 282.893 194.864 L 262.393 194.864 L 262.393 174.364 L 276.493 174.364 L 279.653 171.214 L 260.823 171.214 C 259.95 171.214 259.243 171.921 259.243 172.794 L 259.243 196.434 C 259.243 197.306 259.95 198.014 260.823 198.014 L 284.473 198.014 C 285.344 198.014 286.048 197.305 286.043 196.434 L 286.043 181.774 L 282.893 184.924 Z"
      fill="rgb(18, 114, 109)"
    />
    <path
      d="M 290.873 171.824 L 287.533 168.474 C 286.914 167.865 285.922 167.865 285.303 168.474 L 282.813 170.964 L 288.393 176.534 L 290.873 174.054 C 291.493 173.439 291.493 172.438 290.873 171.824 Z"
      fill="rgb(18, 114, 109)"
    />
    <path
      d="M 281.143 172.614 L 268.203 185.614 L 266.853 191.614 C 266.718 192.18 267.227 192.689 267.793 192.554 L 273.793 191.184 L 286.723 178.194 Z"
      fill="rgb(18, 114, 109)"
    />
  </SVGIcon>
);

export default Edit;
